<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="495" persistent no-click-animation overlay-color="grey-500">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat height="46" class="transparent">
          <v-toolbar-title class="px-5 subtitle-2 grey-700--text font-weight-semibold">Generación exitosa</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-4 px-5 grey-500--text">
        <v-row class="pt-2 pb-4" align="center">
          <v-col cols="4">
            <v-img :height="120" :src="require(`@/assets/backgrounds/modal-document-create-success.svg`)" />
          </v-col>
          <v-col class="pr-4 pl-8 body-1">
            Generación exitosa del documento <span class="font-weight-medium">{{ typeName }} con folio {{ document.number }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions class="py-2 px-5">
        <v-btn @click="$emit('create-new')" text color="primary">Crear nuevo</v-btn>
        <v-spacer />
        <v-btn :to="{ name: 'DocumentsList', query: { ref: 'initial' }, params: { ...$route.params } }" outlined>Ver todos</v-btn>
        <v-btn :to="{ name: 'DocumentsRetrieve', params: { ...$route.params, id: document.id } }" color="blue-500">Ver documento</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DocumentSuccessDialog',
  props: {
    value: { type: Boolean, default: false },
    document: { type: Object, default: () => ({}) },
    typeName: { type: String, default: '' }
  }
}
</script>
